import { render, staticRenderFns } from "./SideNavDropup.vue?vue&type=template&id=6e8f74d2&"
import script from "./SideNavDropup.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideNavDropup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SideNavDropup.vue?vue&type=style&index=0&id=6e8f74d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports